import { bool, shape, string } from 'prop-types';
import { Notification } from '@andes/badge';
import { getIcon } from '../../action-row/icon-helper';
import ErrorMessage from '../../error-message';
import IconFactory from '../../icons/factory-builder';

const Icon = ({ id, className, isMobile }) => (isMobile ? getIcon(id) : IconFactory(id, className));

const ErrorMessageComponent = ({ isMobile, error, namespace }) => {
  if (isMobile) {
    return (
      <div className={`${namespace}__box__error_message`}>
        <Notification type="error" size="small" />
        <p className={`${namespace}__box__error_message__label`}>{error.text}</p>
      </div>
    );
  }

  return <ErrorMessage color={error.color} icon={error.text_icon} text={error.text} namespace={namespace} />;
};

const VariationsTitle = ({ label = '', value, pickerLabelId, error, isMobile = false, namespace = '', icon }) => {
  const { show: showValue = true } = value;
  return (
    <>
      <span>{label}</span>
      {icon?.show && <Icon id={icon.id} className={icon.className} isMobile={isMobile} />}
      {showValue && !!value?.text && (
        <span id={pickerLabelId} className={value.className}>
          {value.text}
        </span>
      )}
      {error?.show && <ErrorMessageComponent error={error.value} isMobile={isMobile} namespace={namespace} />}
    </>
  );
};

VariationsTitle.propTypes = {
  label: string,
  value: shape({
    className: string,
    text: string,
    show: bool,
  }),
  pickerLabelId: string,
  isMobile: bool,
  error: shape({
    value: shape({}),
    show: bool,
  }),
  namespace: string,
  icon: shape({
    id: string,
    className: string,
    show: bool,
  }),
};

ErrorMessageComponent.propTypes = {
  isMobile: bool,
  error: shape({}),
  namespace: string,
};

export default VariationsTitle;
